export default __webpack_public_path__ + "static/media/lib-template1.636e15b9.png";